<div class="form-group">
  <div [class.half]="symbolSize==='half'" [class.double]="symbolSize==='double'" class="preview">
    <svg width="80" height="80">
      <polygon points="0 0,80 0,80 80,0 80,0 0" stroke-width="1" stroke="#000000cc" fill="#cccccc88"></polygon>
      <line x1="0" y1="40" x2="80" y2="40" stroke-width=1 stroke="#00f" stroke-dasharray="2 3"></line>
      <line stroke="#00f" x1="40" y1="0" x2="40" y2="80" stroke-width="1" stroke-dasharray="2 3"></line>
    </svg>
    <div class="icon">
      <span [style.margin-top]="GetIconOffsetY()" [style.margin-left]="GetIconOffsetX()" [style.color]="color"
        [class]="symbolCSS"></span>
    </div>
  </div>
  <div class="icon-grid">
    <div class="icon-set" *ngFor="let row of 6|iterate">
      <app-attribute-option-point-swatch [color]="color" (keydown)="HandleSymbolDown($event)" (keyup)="HandleSymbolKey($event,col,row)"
      (dblclick)="EnterSymbol(col,row)" (click)="SelectSymbol(col,row)" *ngFor="let col of 4|iterate" [symbol]="GetSymbol(col,row)">
      </app-attribute-option-point-swatch>

    </div>
  </div>
</div>
<div class="form-group input-section">
  <label class="section-title">Font Awesome Symbols</label>
  <div class="app-row">
    <input [(ngModel)]="styleName" type="text" class="form-control">
    <div class="form-check">
      <input [(ngModel)]="faStyle" type="radio" name="faStyle" value="solid" class="form-check-input">
      <label class="form-check-label">Solid</label>
    </div>
    <div class="form-check">
      <input [(ngModel)]="faStyle" type="radio" name="faStyle" value="regular" class="form-check-input">
      <label class="form-check-label">Regular</label>
    </div>
  </div>
  <label class="section-title">Symbol Offsets</label>
  <div class="hint">Offset units based on symbol size=32 x 32px regardless of symbol size selection. Try 16px for
    half-symbol offsets.</div>
  <div class="app-row">
    <div class="form-group-horizontal">
      <span class="inline-icon fas fa-arrows-alt-h"></span>
      <input type="number" class="form-control" [(ngModel)]="offsetX"><span class="unit-label">pixels</span>
    </div>
    <div class="form-group-horizontal">
      <span class="inline-icon fas fa-arrows-alt-v"></span>
      <input type="number" class="form-control" [(ngModel)]="offsetY"><span class="unit-label">pixels</span>
    </div>
  </div>
  <div class="description">
    <p>
      The icons provided here are a small sample of the icons available at <a target="_blank"
        href="https://fontawesome.com/v5/search?m=free&s=regular%2Csolid">Font Awesome</a>. Any free solid or regular
      symbol name from Font Awesome may be entered above. Use the offsets above to position the icon relative to point's
      center.
    </p>
  </div>

</div>
